export default "__VITE_ASSET__DqCMOypJ__"